import { types } from 'mobx-state-tree';

import CancelRefusalClaimReasonValues from '../definitions/CancelRefusalClaimReasonValues';


export default types
    .model('CancelRefusalClaim', {
        id: types.identifier,
        reason: types.enumeration(
            Object.values(CancelRefusalClaimReasonValues),
        ),
        date: types.string,
    });
